import { ErrorType } from "../../models/HttpError";
import { HCVisit } from "../../models/Entities/Protocols/HCVisit";


export const VISIT_CONCEPTS_REQUEST = 'VISIT_CONCEPTS_REQUEST';
export const VISIT_CONCEPTS_SUCCESS = 'VISIT_CONCEPTS_SUCCESS';
export const VISIT_CONCEPTS_FAILURE = 'VISIT_CONCEPTS_FAILURE';
export const VISIT_CONCEPTS_CLEAR = 'VISIT_CONCEPTS_CLEAR';

export interface VisitConceptsRequestAction {
    type: typeof VISIT_CONCEPTS_REQUEST;
    protocolId: number;
    visitId: number;
    patientId: string;
}

export interface VisitConceptsSuccessAction {
    type: typeof VISIT_CONCEPTS_SUCCESS;
    payload: HCVisit;
}

export interface VisitConceptsFailureAction {
    type: typeof VISIT_CONCEPTS_FAILURE;
    error: ErrorType;
}

export interface VisitConceptsClearAction {
    type: typeof VISIT_CONCEPTS_CLEAR;
}

export type VisitConceptsActionTypes =
    | VisitConceptsRequestAction
    | VisitConceptsSuccessAction
    | VisitConceptsFailureAction
    | VisitConceptsClearAction;
